export const GRAPH_NUMBER_OF_STEPS = 4;
